import { ChildrenProps, ReactNode } from 'react';

import { Row } from 'components/Blocks';
import { FullHeightContainer } from 'components/FullHeightContainer';

import { Header } from './Header';
import { SideBar } from './SideBar';
import { AppWrapperProvider } from './WrapperContext';

import { NODE_IDS } from 'utils/constants';
import { Footer } from './Footer';
import { useWindowSize } from 'hooks';

interface AppWrapperProps extends ChildrenProps {
  leftContent: ReactNode;
  leftContentOnMobile?: 'top' | 'bottom';
}

export function AppWrapper({
  children,
  leftContent,
  leftContentOnMobile = 'top',
}: AppWrapperProps) {
  const { breakpoints } = useWindowSize();

  const isMobile = breakpoints.SMALL_TABLET;

  const mobileTop = leftContentOnMobile === 'top';

  return (
    <AppWrapperProvider>
      <div className="flex h-full flex-col">
        <Header />

        <Row className="flex-1" gap="2" alignItems="stretch">
          <FullHeightContainer
            className="flex w-full flex-1 small_tablet:flex-col"
            manageOverflow={false}
          >
            <SideBar />

            {!isMobile && (
              <div className="h-full w-full max-w-[440px] flex-shrink-[1.5] border-r border-r-primary-light/40">
                {leftContent}
              </div>
            )}

            <div
              id={NODE_IDS.appScrollable}
              className="scrollbar flex w-full flex-col overflow-y-auto pt-4 small_tablet:flex-1"
            >
              {isMobile && mobileTop && <div className="mb-6 w-full">{leftContent}</div>}

              <div className="w-full px-8 small_tablet:pb-4 phone:px-4">{children}</div>

              {isMobile && !mobileTop && <div className="mb-6 w-full">{leftContent}</div>}

              <Footer />
            </div>
          </FullHeightContainer>
        </Row>
      </div>
    </AppWrapperProvider>
  );
}
